var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 11.2994C7.53335 11.2994 7.06668 11.1194 6.71335 10.7661L2.36668 6.41942C2.17335 6.22608 2.17335 5.90608 2.36668 5.71275C2.56001 5.51942 2.88001 5.51942 3.07335 5.71275L7.42001 10.0594C7.74001 10.3794 8.26001 10.3794 8.58001 10.0594L12.9267 5.71275C13.12 5.51942 13.44 5.51942 13.6333 5.71275C13.8267 5.90608 13.8267 6.22608 13.6333 6.41942L9.28668 10.7661C8.93335 11.1194 8.46668 11.2994 8.00001 11.2994Z",
    fill: "#9186A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownGray);
export default __webpack_public_path__ + "static/media/arrow-down-gray.8dff4ea05abb6fab1a5cc74d29a4a37f.svg";
export { ForwardRef as ReactComponent };